import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { AuthPage, useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFactorSetupIntro',
  setup(__props) {

const { page } = storeToRefs(useAuthStore())

return { __sfc: true,page, AuthPage }
}

})